import { GuestInfoProps } from '@msc-b2c/interfaces/types';
import { GuestInfo } from './GuestInfo';

export function GuestInfoWrapper(props: Readonly<GuestInfoProps>) {
  return <GuestInfo {...props} />;
}

GuestInfoWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/guestinfo';

export default GuestInfoWrapper;
